import axios, { AxiosError } from "axios";
import * as Sentry from "@sentry/react";

type AxiosErrorExtras = {
  url?: string;
  method?: string;
  status?: number;
  responseData?: unknown;
  responseHeaders?: unknown;
  requestHeaders?: unknown;
  requestData?: unknown;
  message?: string;
  code?: string;
};

export function reportAxiosError(error: unknown) {
  if (!axios.isAxiosError(error)) {
    Sentry.captureException(error);
    return;
  }

  const axiosError = error as AxiosError;
  const extras: AxiosErrorExtras = {
    url: axiosError.config?.url,
    method: axiosError.config?.method,
    status: axiosError.response?.status,
    responseData: axiosError.response?.data,
    responseHeaders: axiosError.response?.headers,
    requestHeaders: axiosError.config?.headers,
    requestData: axiosError.config?.data,
    message: axiosError.message,
    code: axiosError.code,
  };

  Sentry.captureException(axiosError, {
    tags: {
      axios: "true",
      status: extras.status ? String(extras.status) : "no_status",
      method: extras.method ?? "no_method",
    },
    extra: extras,
  });
}
